<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>

    <v-container fluid>
      <!-- <div class="addingItemComponentForm"> -->
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Datum izdavanja"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 pa-2 v-if="tip_dokumenta === 'MMI' || ID === 0"> </v-flex>
          <v-flex xs3 pa-2 v-else>
            <v-text-field
              v-model="magacin_prijema"
              label="Magacin izdavanja"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted2"
                label="Datum prijema"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date2 = parseDate(dateFormatted2)"
              ></v-text-field>
              <v-date-picker
                v-model="date2"
                no-title
                @input="menu2 = false"
                :max="maxDate"
                :min="date"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-menu
              ref="menu12"
              :close-on-content-click="false"
              v-model="menu12"
              :nudge-right="0"
              :return-value.sync="time2"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="time2"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time2"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu12.save(time2)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu12 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 pa-2 v-if="tip_dokumenta === 'MMI' || ID === 0">
            <v-autocomplete
              ref="element_1"
              v-model="warehouses_select"
              :items="items_warehouses"
              item-text="name"
              item-value="id"
              label="Magacin prijema"
              persistent-hint
              return-object
              :disabled="ID > 0"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs3 pa-2 v-if="tip_dokumenta === 'MMI' || ID === 0">
            <v-autocomplete
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Izdao"
              persistent-hint
              return-object
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :clearable="edit_form && tip_dokumenta === 'MMI'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-2 v-else>
            <v-autocomplete
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Izdao"
              persistent-hint
              return-object
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
              :clearable="edit_form && tip_dokumenta === 'MMI'"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs3
            pa-2
            style="text-align: right"
            v-if="tip_dokumenta === 'MMI' || ID === 0"
          >
            <v-autocomplete
              ref="element_2"
              v-model="receive_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :clearable="edit_form && tip_dokumenta === 'MMI'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-2 style="text-align: right" v-else>
            <v-autocomplete
              ref="element_2"
              v-model="receive_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
              :clearable="edit_form && tip_dokumenta === 'MMI'"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-2 v-if="tip_dokumenta === 'MMP'">
            <v-autocomplete
              v-model="give_to_select_output"
              :items="employee_to_items_output"
              :item-text="getFieldText"
              item-value="id"
              label="Predao"
              persistent-hint
              return-object
              :disabled="!edit_form"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :clearable="edit_form"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-2 v-else>
            <v-autocomplete
              v-model="give_to_select_output"
              :items="employee_to_items_output"
              :item-text="getFieldText"
              item-value="id"
              label="Predao"
              persistent-hint
              return-object
              :disabled="!edit_form"
              :clearable="edit_form"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs3
            pa-2
            style="text-align: right"
            v-if="tip_dokumenta === 'MMP'"
          >
            <v-autocomplete
              v-model="receive_to_select_output"
              :items="employee_to_items_output"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :disabled="!edit_form"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :clearable="edit_form"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 pa-2 style="text-align: right" v-else>
            <v-autocomplete
              v-model="receive_to_select_output"
              :items="employee_to_items_output"
              :item-text="getFieldText"
              item-value="id"
              label="Primio"
              persistent-hint
              return-object
              :disabled="!edit_form"
              :clearable="edit_form"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-text-field
              ref="element_3"
              v-model="opis"
              label="Opis za magacin izdavanja"
              :disabled="!edit_form || tip_dokumenta !== 'MMI'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-text-field
              v-model="opis_novi"
              label="Opis za magacin prijema"
              :disabled="!edit_form"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 pa-2 style="text-align: center">
            <v-btn
              id="HistoryButton"
              @click="otvoriModal"
              v-if="
                edit_form &&
                (tip_dokumenta === 'MMI' || ID === 0) &&
                !executed_document
              "
            >
              <p>
                <v-icon>close</v-icon>
              </p> </v-btn
            ><!-- /#HistoryButton -->
          </v-flex>
        </v-layout>
        <v-layout column>
          <v-flex style="overflow: auto">
            <v-data-table
              :headers="headers_modal"
              :items="items_modal_pom"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props_modal">
                <td
                  style="
                    padding-left: 0px;
                    padding-right: 0px;
                    text-align: center;
                  "
                >
                  {{ props_modal.item.wine.label }} -
                  {{ props_modal.item.wine.year }}
                </td>
                <!-- <td>
                  {{
                    formatDateTime(props_modal.item.bottling.dateOfProduction)
                  }}
                </td> -->
                <td>
                  {{ props_modal.item.bottling.lot }}
                </td>
                <!-- <td>
                  {{ props_modal.item.bottling.tank }}
                </td> -->
                <td>{{ props_modal.item.bottling.bottleVolumeInLitres }}l</td>
                <td>
                  {{ props_modal.item.quantity }}
                </td>
                <td
                  class="DataTable__ButtonHolder"
                  style="text-align: center; padding-left: 0px !important"
                >
                  <img
                    v-if="edit_form"
                    class="DataTable__Button"
                    title="Izmena"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    v-else
                    class="DataTable__Button"
                    title="Pregled"
                    src="../assets/icons/zatabele/ico-view.png"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItemModal(props_modal.item)"
                    v-if="edit_form && (tip_dokumenta === 'MMI' || ID === 0)"
                  />
                </td>
              </template>
              <template slot="no-data">
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs1
            style="text-align: left; margin-bottom: 0px; padding-top: 15px"
          >
            <img
              class="DataTable__Button"
              title="Štampa dokumenta"
              src="../assets/menuIcons/ico-print.png"
              alt="delete-item"
              @click="printItem(print_item, print_item_out)"
              style="width: 48px !important; height: 48px !important"
              v-if="ID > 0 && print_item.number.substring(0, 3) === 'MMI'"
            />
          </v-flex>
          <v-flex
            xs11
            style="text-align: right; margin-bottom: 0px; padding-top: 15px"
          >
            <v-btn
              :disabled="!valid"
              @click="submit"
              class="AppButtonFilled"
              v-if="edit_form"
              >Sačuvaj</v-btn
            >
            <v-btn
              id="Odustani_dugme"
              @click="clear"
              class="AppButtonOutlined"
              v-if="edit_form"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>
      <v-dialog
        v-model="dialogSave"
        scrollable
        content-class="ModalInModalMali"
      >
        <v-container>
          <div class="DataTable">
            <v-form
              ref="form_modal_save"
              v-model="validModalSave"
              lazy-validation
            >
              <a class="closeModalInModalBtn" @click.prevent="closeModalSave">
                <v-icon>close</v-icon>
              </a>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-subheader style="font-size: 18px"
                    >Da li želite da izvršite dokumente:</v-subheader
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 pa-2>
                  <v-checkbox
                    style="margin-top: 0px !important"
                    :label="MMILabel"
                    v-model="valueMMI"
                    :checked="valueMMI"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6 pa-2>
                  <v-checkbox
                    style="margin-top: 0px !important"
                    :label="MMPLabel"
                    v-model="valueMMP"
                    :checked="valueMMP"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 style="text-align: right; margin-bottom: 0px">
                  <v-btn
                    :disabled="!validModalSave"
                    @click="submit_save"
                    class="AppButtonFilled"
                    >Izvrši</v-btn
                  >
                  <v-btn
                    id="Odustani_dugme"
                    @click="closeModalSave"
                    class="AppButtonOutlined"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-container>
      </v-dialog>

      <v-dialog
        v-model="dialogSaveExecuted"
        scrollable
        content-class="ModalInModalMali"
      >
        <v-container>
          <div class="DataTable">
            <v-form
              ref="form_modal_save"
              v-model="validModalSave"
              lazy-validation
            >
              <a
                class="closeModalInModalBtn"
                @click.prevent="closeModalSaveExecuted"
              >
                <v-icon>close</v-icon>
              </a>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-subheader style="font-size: 18px"
                    >Da li želite da izvršite dokument:</v-subheader
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 pa-2>
                  <v-checkbox
                    style="margin-top: 0px !important"
                    :label="MMPLabel"
                    v-model="valueMMP"
                    :checked="valueMMP"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 style="text-align: right; margin-bottom: 0px">
                  <v-btn
                    :disabled="!validModalSave"
                    @click="submit_save_executed"
                    class="AppButtonFilled"
                    >Izvrši</v-btn
                  >
                  <v-btn
                    id="Odustani_dugme"
                    @click="closeModalSaveExecuted"
                    class="AppButtonOutlined"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-container>
      </v-dialog>

      <v-dialog
        v-model="dialogNote"
        scrollable
        content-class="ModalInModalMali"
      >
        <v-container>
          <div class="DataTable">
            <v-form ref="form_modal" v-model="validModal" lazy-validation>
              <a
                class="closeModalInModalBtn"
                @click.prevent="closeModalInModal"
              >
                <v-icon>close</v-icon>
              </a>
              <!-- /.closeModalBtn -->
              <v-layout row wrap>
                <v-flex xs12 pa-2>
                  <v-autocomplete
                    v-model="wine_to_select"
                    :items="wine_to_items"
                    :item-text="getFieldTextWine"
                    item-value="id"
                    label="Vino"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeWine"
                    :disabled="!edit_form || tip_dokumenta !== 'MMI'"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs9
                  pa-2
                  v-if="
                    edit_form &&
                    tip_dokumenta === 'MMI' &&
                    !wine_to_select_disable
                  "
                >
                  <v-autocomplete
                    v-model="wh_state_to_select"
                    :items="wh_state_to_items"
                    :item-text="getFieldTextBottling"
                    item-value="bottlingId"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="Lot - Stanje boca"
                    required
                    persistent-hint
                    return-object
                    :disabled="!edit_form"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs9 pa-2 v-else-if="tip_dokumenta === 'MMI'">
                  <!-- :item-text="getFieldTextBottling" -->
                  <v-text-field
                    v-model="pomocni_text"
                    label="Lot"
                    persistent-hint
                    return-object
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 pa-2>
                  <v-text-field
                    v-model="quantity"
                    label="Broj boca"
                    type="number"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs12
                  style="
                    text-align: right;
                    margin-bottom: 0px;
                    padding-top: 15px;
                  "
                >
                  <v-btn
                    :disabled="!validModal"
                    @click="submit_modal"
                    class="AppButtonFilled"
                    v-if="edit_form"
                    >Sačuvaj</v-btn
                  >
                  <v-btn
                    @click="clear_modal"
                    class="AppButtonOutlined"
                    v-if="edit_form"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>
      <TokenComponent ref="frmtoken" />
    </v-container>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import html2pdf from "html2pdf.js";

export default {
  name: "WareHouseOutputOff",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    menu: "",
    menu1: "",
    time: "",
    date: null,
    menu2: "",
    menu12: "",
    time2: "",
    date2: null,
    valid: true,
    validModal: true,
    menuModal: "",
    menu1Modal: "",
    menuVazenja: "",
    menu1Vazenja: "",
    dateFormatted: null,
    dateFormatted2: null,
    naziv: "",
    ID: 0,
    type: "",
    output: true,
    receive_id: 0,
    opis: "",
    opis_novi: "",
    employee_to_items: [],
    employee_to_items_output: [],
    article_to_items: [],
    article_to_select: 0,
    wh_state_to_items: [],
    wh_state_to_select: 0,
    pomocni_text: "",
    give_to_select: 0,
    give_to_select_output: 0,
    receive_to_select: 0,
    receive_to_select_output: 0,
    opis: "",
    dialogNote: false,
    index_izmene: -1,
    izmena_modal: true,
    quantity: undefined,
    jm_select: "",
    jm_items: [],
    // currency_items: [],
    // jm_valuta: undefined,
    items_modal: [],
    items_modal_pom: [],
    headers_modal: [
      { text: "Vino", value: "wine.label", align: "center" },
      // { text: "Flasirano", value: "bottling.dateOfProduction" },
      { text: "Lot", value: "bottling.lot", align: "left" },
      // { text: "Tank", value: "bottling.tank" },
      { text: "Boca", value: "bottling.bottleVolumeInLitres", align: "left" },
      {
        text: "Broj boca",
        value: "quantity",
        align: "left",
        style: "width: 15%",
      },
      // { text: "JM", value: "width" },
      { text: "Funkcije", value: "funkcije", align: "center", sortable: false },
    ],
    warehouseID: 0,
    warehouseType: "",
    warehouseTypeId: 0,
    edit_form: true,
    pomocni_id: 0,
    number: "",
    globBottlingID: 0,
    items: [],
    items_warehouses: [],
    warehouses_select: 0,
    wh_state_to_select: 0,
    wh_state_to_items: [],
    wine_to_select: 0,
    wine_to_items: [],
    IDinput: 0,
    numberinput: "",
    tip_dokumenta: "MMI",
    magacin_prijema: "",
    wine_to_select_disable: false,
    pomocni_text_pom: "",
    dialogSave: false,
    dialogSaveExecuted: false,
    valueMMP: undefined,
    valueMMI: true,
    MMPLabel: "MMP",
    MMILabel: "MMI",
    MMPID: 0,
    MMIID: 0,
    validModalSave: true,
    executed_document: false,
    date_document: undefined,

    modal_lot: "",
    modal_zapremina: 0,
    pronadjiObjNovi: undefined,
    postoji: false,
    promeni_lot: false,
    print_item: [],
    print_item_out: [],
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    date2(val) {
      this.dateFormatted2 = this.formatDate1(this.date2);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    printItem(item, item_out) {
      this.isLoading = true;

      this.getMaticniPodaciIzdatnica(item, item_out);
    },
    getMaticniPodaciIzdatnica(item, item_out) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/winery_data", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          if(localStorage.getItem("vinarija") === "fruvin" || localStorage.getItem("vinarija") === "winedb")
            this.stampaj_mmi_fruvin(item, item_out, response.data);
                      else
                        this.stampaj_mmi(item, item_out, response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/winery_data",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if(localStorage.getItem("vinarija") === "fruvin" || localStorage.getItem("vinarija") === "winedb")
            this.stampaj_mmi_fruvin(item, item_out, response.data);
                      else
                        this.stampaj_mmi(item, item_out, response.data);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    stampaj_mmi(item, item_out, object) {
      let _this = this;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.name;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.city;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "PIB: " + object.taxNumber;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "MB: " + object.identityNumber;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML = "Međumagacinski prenos br. " + item.number;
        else elementToPrint2.innerHTML = "Međumagacinski prenos br. " + item.documentNumber;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.left = "25%";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Datum prenosa :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Izlazni magacin: " + item.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Magacin prijema: " + item_out.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("Lot");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("JM");
          //cell
          //else if (j === 5) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "20%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "20%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName + " " + item.warehouseInputOutputItems[i].wineYear
                );
            }
            //cell
            else if (j === 4) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 2)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].lot
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    
    stampaj_mmi_fruvin(item, item_out, object) {
      let _this = this;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrintImg = document.createElement("div");
        elementToPrintImg.style.width = "50%";
        elementToPrintImg.style.float = "left";

        var elementToPrintZaglavlje = document.createElement("div");
        elementToPrintZaglavlje.style.width = "50%";
        elementToPrintZaglavlje.style.margin = "10px 0px 0px 0%";
        elementToPrintZaglavlje.style.float = "right";

        var elementToPrint1 = document.createElement("img");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "0px 0px 0px 0%";
        elementToPrint1.src = '../assets/wineries/' + localStorage.getItem("vinarija") + '/logo.png';
        elementToPrintImg.append(elementToPrint1);

        elementToPrint.append(elementToPrintImg);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        elementToPrint1.innerHTML = object.name;
          elementToPrint1.style.fontSize = '10px';
        elementToPrint1.style.fontWeight = "bold";

        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
          elementToPrint1.style.fontSize = '10px';
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Telefon: " + object.phone;
          elementToPrint1.style.fontSize = '10px';
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "PIB: " + (object.taxNumber !== null ? object.taxNumber : "") + " / " + "MB: " + (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
          elementToPrint1.style.fontSize = '10px';
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 5px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.email + " / " + "www.fruvin.com";
          elementToPrint1.style.fontSize = '10px';
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint.append(elementToPrintZaglavlje);

        var nizRacun = object.bankAccount.split("|");
        var nizBanka = object.bankName.split("|");

        for (var j = 0; j < nizBanka.length; j++) {
          elementToPrint1 = document.createElement("p");
          elementToPrint1.style.margin = "3px 0px 0px 50%";
          // elementToPrint1.style.margin = "5px 0px 0px 10px";
          elementToPrint1.innerHTML = nizRacun[j] + " " + nizBanka[j];
          elementToPrint1.style.fontWeight = "bold";
          elementToPrint1.style.fontSize = '10px';
          elementToPrint.append(elementToPrint1);
        }

        var elementToPrint22222 = document.createElement("p");
        elementToPrint22222.innerHTML = "&nbsp;&nbsp;";
        elementToPrint.append(elementToPrint22222);

        var elementToPrint22 = document.createElement("div");

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML = "Međumagacinski prenos br. " + item.number;
        else elementToPrint2.innerHTML = "Međumagacinski prenos br. " + item.documentNumber;

        // elementToPrint2.style.position = "relative";
        elementToPrint2.style.margin = "5px 0px 0px 10px";
        elementToPrint2.style.textAlign = "center"
        elementToPrint2.style.fontSize = "20px";
        elementToPrint22.append(elementToPrint2);

        elementToPrint.append(elementToPrint22);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Datum prenosa :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Izlazni magacin: " + item.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Magacin prijema: " + item_out.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("Lot");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("JM");
          //cell
          //else if (j === 5) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "20%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "20%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (item.warehouseInputOutputItems[i].bottleVolumeInLitres !== null)
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolumeInLitres +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 4) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 2)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].lot
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

elementToPrint1 = document.createElement("p");
//format za margin ide "top, right, bottom, left"
elementToPrint1.style.margin = "15px 0px 0px 10px";
elementToPrint1.innerHTML =
  "Napomena: " + (this.opis === null || this.opis === undefined ? "" : this.opis);
// elementToPrint1.style.fontSize = '20px';
elementToPrint.append(elementToPrint1);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    getFieldTextBottling(item) {
      let pomString = "";
      if (typeof item.tank === "undefined")
        pomString = `${item.lot} - ${item.quantityState} boca`;
      // x ${item.bottleVolumeInLitres}l`;
      else pomString = `${item.lot} - ${item.quantityState} boca`; // x ${item.bottleVolumeInLitres}l`;

      return pomString;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
      this.time2 = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      this.date2 = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    wait: function (ms) {
      var start = Date.now(),
        now = start;
      while (now - start < ms) {
        now = Date.now();
      }
    },
    closeModalSave() {
      this.dialogSave = false;
      // this.clear();
    },
    submit_save_executed() {
      if (this.valueMMP) this.prijemDokumenta(this.MMPID);
    },

    closeModalSaveExecuted() {
      this.dialogSaveExecuted = false;
      // this.clear();
    },
    getAllEmployees() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.employee_to_items = response.data;
          this.employee_to_items_output = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;
                      this.employee_to_items_output = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getAllWine() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/wines/" +
            this.warehouseID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.wine_to_items = response.data;

          // if (response.data.length === 1)
          //   this.wine_to_select = response.data[0];
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/wines/" +
                        this.warehouseID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_to_items = response.data;

                      // if (response.data.length === 1)
                      //   this.wine_to_select = response.data[0];
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllWareHouseState(a) {
      let _this = this;
      let url = "/warehouse_state/lots/" + this.warehouseID + "/" + a;

      if (this.executed_document)
        url = url + "?lot=" + this.modal_lot + "&date=" + this.date_document;

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          _this.wh_state_to_items = response.data;

          if (_this.globBottlingID !== 0) {
            let pronadjiObj = _this.wh_state_to_items.find(
              (item1) => item1.stateId === _this.globBottlingID
            );

            if (pronadjiObj !== undefined)
              _this.wh_state_to_select = pronadjiObj;
            else {
              if (_this.wh_state_to_items.length !== 0) {
                if (_this.modal_lot !== "" && _this.modal_lot !== null) {
                  pronadjiObj = _this.wh_state_to_items.filter(function (
                    item1
                  ) {
                    return item1.lot === _this.modal_lot;
                  });

                  if (pronadjiObj.length > 0) {
                    pronadjiObj[0].quantityState = pronadjiObj[0].quantityState; //+ _this.quantity;
                    _this.wh_state_to_select = pronadjiObj[0];
                  } else if (_this.postoji) {
                    let pomObj = {
                      articleId: _this.pronadjiObjNovi.id,
                      bottleVolumeInLitres: _this.modal_zapremina,
                      lot: _this.modal_lot,
                      materialInputId: null,
                      price: null,
                      quantityState: this.quantity,
                      quantityStateInLitres: null,
                      stateId: _this.globBottlingID,
                      unitOfMeasure: {
                        id: null,
                        mark: null,
                        name: null,
                      },
                      validTo: null,
                      value: null,
                    };

                    _this.wh_state_to_items.push(pomObj);
                    _this.wh_state_to_select = pomObj;
                  }
                }

                this.wine_to_select_disable = false;

                if (response.data.length === 1)
                  _this.wh_state_to_select = response.data[0];
              } else {
                // let pomObj = {
                //   articleId: _this.pronadjiObjNovi.id,
                //   bottleVolumeInLitres: _this.modal_zapremina,
                //   lot: _this.modal_lot,
                //   materialInputId: null,
                //   price: null,
                //   quantityState: this.quantity,
                //   quantityStateInLitres: null,
                //   stateId: _this.globBottlingID,
                //   unitOfMeasure: {
                //     id: null,
                //     mark: null,
                //     name: null,
                //   },
                //   validTo: null,
                //   value: null,
                // };

                // _this.wh_state_to_items.push(pomObj);
                // _this.wh_state_to_select = pomObj;

                this.wine_to_select_disable = true;
              }
            }
          } else if (response.data.length === 1)
            _this.wh_state_to_select = response.data[0];
          else {
            if (_this.wh_state_to_items.length !== 0) {
              if (_this.modal_lot !== "" && _this.modal_lot !== null) {
                let pronadjiObj;

                pronadjiObj = response.data.filter(function (item1) {
                  return item1.lot === _this.modal_lot;
                });

                if (pronadjiObj.length > 0 && _this.executed_document) {
                  // pronadjiObj[0].bottlesUnreceived =
                  //   pronadjiObj[0].bottledNumber;

                  pronadjiObj[0].bottlesUnreceived =
                    pronadjiObj[0].bottlesUnreceived + _this.quantity;
                } else {
                  let pomObj = {
                    bottledNumber: 0,
                    bottlesUnreceived: _this.quantity,
                    lot: _this.modal_lot,
                    bottleVolumeInLiters: _this.modal_zapremina,
                    bottlingId: null,
                  };

                  _this.wh_state_to_items.push(pomObj);
                  _this.wh_state_to_select = pomObj;
                }
              }

              if (response.data.length === 1)
                _this.wh_state_to_select = response.data[0];
            }
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      _this.wh_state_to_items = response.data;

                      if (_this.globBottlingID !== 0) {
                        let pronadjiObj = _this.wh_state_to_items.find(
                          (item1) => item1.stateId === _this.globBottlingID
                        );

                        if (pronadjiObj !== undefined)
                          _this.wh_state_to_select = pronadjiObj;
                        else {
                          if (_this.wh_state_to_items.length !== 0) {
                            if (
                              _this.modal_lot !== "" &&
                              _this.modal_lot !== null
                            ) {
                              pronadjiObj = _this.wh_state_to_items.filter(
                                function (item1) {
                                  return item1.lot === _this.modal_lot;
                                }
                              );

                              if (pronadjiObj.length > 0) {
                                pronadjiObj[0].quantityState =
                                  pronadjiObj[0].quantityState; //+ _this.quantity;
                                _this.wh_state_to_select = pronadjiObj[0];
                              } else if (_this.postoji) {
                                let pomObj = {
                                  articleId: _this.pronadjiObjNovi.id,
                                  bottleVolumeInLitres: _this.modal_zapremina,
                                  lot: _this.modal_lot,
                                  materialInputId: null,
                                  price: null,
                                  quantityState: this.quantity,
                                  quantityStateInLitres: null,
                                  stateId: _this.globBottlingID,
                                  unitOfMeasure: {
                                    id: null,
                                    mark: null,
                                    name: null,
                                  },
                                  validTo: null,
                                  value: null,
                                };

                                _this.wh_state_to_items.push(pomObj);
                                _this.wh_state_to_select = pomObj;
                              }
                            }

                            this.wine_to_select_disable = false;

                            if (response.data.length === 1)
                              _this.wh_state_to_select = response.data[0];
                          } else {
                            // let pomObj = {
                            //   articleId: _this.pronadjiObjNovi.id,
                            //   bottleVolumeInLitres: _this.modal_zapremina,
                            //   lot: _this.modal_lot,
                            //   materialInputId: null,
                            //   price: null,
                            //   quantityState: this.quantity,
                            //   quantityStateInLitres: null,
                            //   stateId: _this.globBottlingID,
                            //   unitOfMeasure: {
                            //     id: null,
                            //     mark: null,
                            //     name: null,
                            //   },
                            //   validTo: null,
                            //   value: null,
                            // };

                            // _this.wh_state_to_items.push(pomObj);
                            // _this.wh_state_to_select = pomObj;

                            this.wine_to_select_disable = true;
                          }
                        }
                      } else if (response.data.length === 1)
                        _this.wh_state_to_select = response.data[0];
                      else {
                        if (_this.wh_state_to_items.length !== 0) {
                          if (
                            _this.modal_lot !== "" &&
                            _this.modal_lot !== null
                          ) {
                            let pronadjiObj;

                            pronadjiObj = response.data.filter(function (
                              item1
                            ) {
                              return item1.lot === _this.modal_lot;
                            });

                            if (
                              pronadjiObj.length > 0 &&
                              _this.executed_document
                            ) {
                              // pronadjiObj[0].bottlesUnreceived =
                              //   pronadjiObj[0].bottledNumber;

                              pronadjiObj[0].bottlesUnreceived =
                                pronadjiObj[0].bottlesUnreceived +
                                _this.quantity;
                            } else {
                              let pomObj = {
                                bottledNumber: 0,
                                bottlesUnreceived: _this.quantity,
                                lot: _this.modal_lot,
                                bottleVolumeInLiters: _this.modal_zapremina,
                                bottlingId: null,
                              };

                              _this.wh_state_to_items.push(pomObj);
                              _this.wh_state_to_select = pomObj;
                            }
                          }

                          if (response.data.length === 1)
                            _this.wh_state_to_select = response.data[0];
                        }
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    otvoriModal() {
      this.dialogNote = true;
      // this.getAllArticles();
      // this.getAllJediniceMere();
      // this.getAllValute();
      this.getAllWine();

      this.clear_modal();
    },

    closeModalInModal() {
      this.dialogNote = false;

      this.clear_modal();
    },
    submit_modal() {
      

      let pronadjiObjNovi;

      

      pronadjiObjNovi = this.items_modal_pom.findIndex(
        (item1) =>
          item1.wine.id === this.wh_state_to_select.articleId &&
          item1.bottling.lot === this.wh_state_to_select.lot
      );

      if (pronadjiObjNovi !== -1 && this.index_izmene === -1)
        alert("Izabrano vino i lot već se nalaze u listi.");
      else if (
        this.index_izmene !== -1 &&
        this.index_izmene !== pronadjiObjNovi &&
        pronadjiObjNovi !== -1
      )
        alert("Izabrano vino i lot već se nalaze u listi.");
      else if (this.$refs.form_modal.validate()) {
        if (this.tip_dokumenta === "MMI") {
          // if (
          //   Number(this.wh_state_to_select.quantityState) >=
          //   Number(this.quantity)
          // )
          var complexPouringAdditiv;

          var pom_wmState;

          if (
            typeof this.wh_state_to_select !== "undefined" &&
            this.wh_state_to_select !== "" &&
            this.wh_state_to_select !== 0
          ) {
            if (typeof this.wh_state_to_select.stateId === "undefined")
              pom_wmState = this.wh_state_to_select;
            else pom_wmState = this.wh_state_to_select.stateId;
          }

          var complexPouringAdditivPom;
          if (this.tip_dokumenta === "MMI")
            complexPouringAdditivPom = {
              wine: this.wine_to_select,
              bottling: this.wh_state_to_select,
              quantity: Number(this.quantity),
            };

          if (this.index_izmene !== -1 && this.ID !== 0) {
            complexPouringAdditivPom = this.items_modal_pom[this.index_izmene];
            complexPouringAdditivPom.quantity = Number(this.quantity);

            complexPouringAdditiv = this.items_modal[this.index_izmene];

            if (this.tip_dokumenta === "MMI" && !this.wine_to_select_disable)
              complexPouringAdditiv.warehouseState.id = pom_wmState;

            complexPouringAdditiv.quantity = Number(this.quantity);
          } else if (this.tip_dokumenta === "MMI")
            complexPouringAdditiv = {
              warehouseState: {
                id: pom_wmState,
              },
              quantity: Number(this.quantity),
            };
          else
            complexPouringAdditiv = {
              quantity: Number(this.quantity),
            };
          let pronadjiObjNovi;

          

          pronadjiObjNovi = this.items_modal_pom.findIndex(
            (item1) =>
              item1.wine.id === this.wh_state_to_select.articleId &&
              item1.bottling.lot === this.wh_state_to_select.lot
          );

          if (pronadjiObjNovi !== -1 && this.index_izmene === -1)
            alert("Izabrano vino i lot već se nalaze u listi.");
          else if (
            this.index_izmene !== -1 &&
            this.index_izmene !== pronadjiObjNovi &&
            pronadjiObjNovi !== -1
          )
            alert("Izabrano vino i lot već se nalaze u listi.");
          else {
            if (this.ID !== 0)
              if (this.index_izmene !== -1) {
                // ovde treba da ide poziv nove procedure za izmenu
                this.edit_modal(complexPouringAdditiv, this.tip_dokumenta);
              } else {
                // ovde treba da ide poziv nove procedure za unos stavke
                this.add_modal(complexPouringAdditiv, this.tip_dokumenta);
              }
            else {
              if (this.index_izmene !== -1) {
                this.items_modal.splice(this.index_izmene, 1);
                this.items_modal_pom.splice(this.index_izmene, 1);
              }

              this.items_modal.push(complexPouringAdditiv);
              this.items_modal_pom.push(complexPouringAdditivPom);

              this.clear_modal();
            }
          }
        } //else alert("Izabrali ste veću količinu od raspoložive.");
        else {
          var complexPouringAdditiv;

          var pom_wmState;

          if (
            typeof this.wh_state_to_select !== "undefined" &&
            this.wh_state_to_select !== "" &&
            this.wh_state_to_select !== 0
          ) {
            if (typeof this.wh_state_to_select.stateId === "undefined")
              pom_wmState = this.wh_state_to_select;
            else pom_wmState = this.wh_state_to_select.stateId;
          }

          var complexPouringAdditivPom;
          if (this.tip_dokumenta === "MMI")
            complexPouringAdditivPom = {
              wine: this.wine_to_select,
              bottling: this.wh_state_to_select,
              quantity: Number(this.quantity),
            };

          if (this.index_izmene !== -1) {
            complexPouringAdditivPom = this.items_modal_pom[this.index_izmene];
            complexPouringAdditivPom.quantity = Number(this.quantity);

            complexPouringAdditiv = this.items_modal[this.index_izmene];

            if (this.tip_dokumenta === "MMI" && !this.wine_to_select_disable)
              complexPouringAdditiv.warehouseState.id = pom_wmState;

            complexPouringAdditiv.quantity = Number(this.quantity);
          } else if (this.tip_dokumenta === "MMI")
            complexPouringAdditiv = {
              warehouseState: {
                id: pom_wmState,
              },
              quantity: Number(this.quantity),
            };
          else
            complexPouringAdditiv = {
              quantity: Number(this.quantity),
            };

          if (this.ID !== 0)
            if (this.index_izmene !== -1) {
              // ovde treba da ide poziv nove procedure za izmenu
              this.edit_modal(complexPouringAdditiv, this.tip_dokumenta);
            } else {
              // ovde treba da ide poziv nove procedure za unos stavke
              this.add_modal(complexPouringAdditiv, this.tip_dokumenta);
            }
          else {
            if (this.index_izmene !== -1) {
              this.items_modal.splice(this.index_izmene, 1);
              this.items_modal_pom.splice(this.index_izmene, 1);
            }

            this.items_modal.push(complexPouringAdditiv);
            this.items_modal_pom.push(complexPouringAdditivPom);

            this.clear_modal();
          }
        }
      }
    },
    clear_modal() {
      this.load = 0;
      this.index_izmene = -1;

      this.$refs.form_modal.reset();

      this.izmena_modal = false;

      this.globBottlingID = 0;
      this.wh_state_to_items = [];

      this.modal_lot = "";
      this.modal_zapremina = 0;
      this.pronadjiObjNovi = undefined;
      this.postoji = false;
    },
    clearInit() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();

      let naslov = "";
      naslov =
        "Međumagacinski izlaz &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem ";

      if (this.tip_dokumenta === "MMI" || this.ID === 0)
        this.$refs.element_1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      document.getElementById("naslov").innerHTML = naslov;
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();

      if (this.tip_dokumenta === "MMI" || this.ID === 0)
        this.$refs.element_1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      let naslov = "";

      naslov =
        "Međumagacinski izlaz &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem ";

      document.getElementById("naslov").innerHTML = naslov;
    },
    deleteItemModal(item) {
      

      if (item.id !== undefined) {
        let url =
          "/warehouse_input_output_item/change_warehouse/delete/" + item.id;

        this.$http
          .delete(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            // // // console.log(response);
            alert("Stavka je uspešno obrisana.");
            this.getAllItem(this.ID);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation + this.globalPort + url,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // // console.log(response);
                        alert("Stavka je uspešno obrisana.");
                        this.getAllItem(this.ID);
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      } else {
        const index = this.items_modal_pom.indexOf(item);
        this.items_modal_pom.splice(index, 1);

        this.items_modal.splice(index, 1);
      }
    },
    edit_modal(locObject, type) {
      let complexInput; // = this.vrati_objekat(locObject, type);
      let url; // = "/warehouse_input_output_item/change_warehouse/update";

      if (!this.executed_document) {
        complexInput = this.vrati_objekat(locObject, type);

        if (type === "MMP")
          url = "/warehouse_input_output_item/change_warehouse_input/update";
        else url = "/warehouse_input_output_item/change_warehouse/update";
      } else {
        complexInput = this.vrati_objekat_novo(locObject, type);
        url = "/warehouse_input_output/change_warehouse/update_executed";
      }

      this.$http
        .put(this.globalServiceLocation + this.globalPort + url, complexInput, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + url,
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    add_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type);

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output_item/change_warehouse/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output_item/change_warehouse/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    vrati_objekat_novo(newObject, type) {
      var pomArray = [];
      pomArray.push(newObject);

      var complexInputMax;
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexInput;
      complexInput = {
        id: this.ID,
        number: this.number,
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: "CHANGE_WAREHOUSE_OUTPUT",
        give: {
          id: pom_give_to_select,
        },
        receive: {
          id: pom_receive_to_select,
        },
        description: this.opis,
        warehouseInputOutputItems: pomArray,
        changeWarehouseRelatedId: this.IDinput,
        output: true,
      };

      var pom_warehouses_select;

      if (
        typeof this.warehouses_select !== "undefined" &&
        this.warehouses_select !== ""
      ) {
        if (typeof this.warehouses_select.id === "undefined")
          pom_warehouses_select = this.warehouses_select;
        else pom_warehouses_select = this.warehouses_select.id;
      }

      var complexObjectWareHouseOutput = {
        id: pom_warehouses_select,
      };

      var pom_give_to_select_output = 0;

      if (
        typeof this.give_to_select_output !== "undefined" &&
        this.give_to_select_output !== "" &&
        this.give_to_select_output !== null
      ) {
        if (typeof this.give_to_select_output.id === "undefined")
          pom_give_to_select_output = this.give_to_select_output;
        else pom_give_to_select_output = this.give_to_select_output.id;
      }

      var pom_receive_to_select_output = 0;

      if (
        typeof this.receive_to_select_output !== "undefined" &&
        this.receive_to_select_output !== "" &&
        this.receive_to_select_output !== null
      ) {
        if (typeof this.receive_to_select_output.id === "undefined")
          pom_receive_to_select_output = this.receive_to_select_output;
        else pom_receive_to_select_output = this.receive_to_select_output.id;
      }

      //   complexInput = {
      //   id: this.ID,
      //   warehouseInputOutputItems: pomArray
      // };

      if (type === "MMI") {
        var complexOutput;
        if (
          pom_give_to_select_output !== 0 &&
          pom_receive_to_select_output !== 0
        )
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            give: {
              id: pom_give_to_select_output,
            },
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else if (
          pom_give_to_select_output === 0 &&
          pom_receive_to_select_output === 0
        )
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else if (pom_give_to_select_output === 0)
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            give: {
              id: pom_give_to_select_output,
            },
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };

        complexInputMax = {
          warehouseOutput: complexInput,
          warehouseInput: complexOutput,
        };
      } else {
        complexInputMax = complexInput;
      }

      return complexInputMax;
    },
    vrati_objekat(newObject, type) {
      var pomArray = [];
      pomArray.push(newObject);

      var complexInputMax;
      var complexInput;

      complexInput = {
        id: this.ID,
        warehouseInputOutputItems: pomArray,
      };

      if (type === "MMI") {
        var complexOutput;

        complexOutput = {
          id: this.IDinput,
        };

        console.log(complexInput);

        complexInputMax = {
          warehouseOutput: complexInput,
          warehouseInput: complexOutput,
        };
      } else {
        complexInputMax = complexInput;
      }

      return complexInputMax;
    },
    getAllWareHouses() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse/for_changing_warehouses/" +
            this.warehouseTypeId +
            "/" +
            this.warehouseID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_warehouses = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse/for_changing_warehouses/" +
                        this.warehouseTypeId +
                        "/" +
                        this.warehouseID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_warehouses = response.data;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    newSifarnik() {
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var complexInput;
      complexInput = {
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: "CHANGE_WAREHOUSE_OUTPUT",
        give: {
          id: pom_give_to_select,
        },
        receive: {
          id: pom_receive_to_select,
        },
        description: this.opis,
        warehouseInputOutputItems: this.items_modal,
        output: true,
      };

      var pom_warehouses_select;

      if (
        typeof this.warehouses_select !== "undefined" &&
        this.warehouses_select !== ""
      ) {
        if (typeof this.warehouses_select.id === "undefined")
          pom_warehouses_select = this.warehouses_select;
        else pom_warehouses_select = this.warehouses_select.id;
      }

      var complexObjectWareHouseOutput = {
        id: pom_warehouses_select,
      };

      var pom_give_to_select_output = 0;

      if (
        typeof this.give_to_select_output !== "undefined" &&
        this.give_to_select_output !== ""
      ) {
        if (typeof this.give_to_select_output.id === "undefined")
          pom_give_to_select_output = this.give_to_select_output;
        else pom_give_to_select_output = this.give_to_select_output.id;
      }

      var pom_receive_to_select_output = 0;

      if (
        typeof this.receive_to_select_output !== "undefined" &&
        this.receive_to_select_output !== ""
      ) {
        if (typeof this.receive_to_select_output.id === "undefined")
          pom_receive_to_select_output = this.receive_to_select_output;
        else pom_receive_to_select_output = this.receive_to_select_output.id;
      }

      var complexOutput;
      if (pom_give_to_select_output !== 0 && pom_receive_to_select_output !== 0)
        complexOutput = {
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          give: {
            id: pom_give_to_select_output,
          },
          receive: {
            id: pom_receive_to_select_output,
          },
          description: this.opis_novi,
          input: true,
        };
      else if (
        pom_give_to_select_output === 0 &&
        pom_receive_to_select_output === 0
      )
        complexOutput = {
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          description: this.opis_novi,
        };
      else if (pom_give_to_select_output === 0)
        complexOutput = {
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          receive: {
            id: pom_receive_to_select_output,
          },
          description: this.opis_novi,
          input: true,
        };
      else
        complexOutput = {
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          give: {
            id: pom_give_to_select_output,
          },
          description: this.opis_novi,
          input: true,
        };

      // console.log(complexInput);

      var complexInputMax;
      complexInputMax = {
        warehouseOutput: complexInput,
        warehouseInput: complexOutput,
      };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/change_warehouse/create",
          complexInputMax,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;
          // let pom_poruka;

          // pom_poruka = "dokument izlaza iz magacina";

          // let naslov = document.getElementById("naslov").innerText;
          // document.getElementById("naslov").innerText =
          //   naslov + " " + response.data.outputDocumentNumber;

          let naslov = document.getElementById("naslov");
          naslov.innerHTML =
            "Međumagacinski izlaz " +
            response.data.outputDocumentNumber +
            "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
            response.data.inputDocumentNumber;

          this.ID = response.data.outputId;
          this.IDinput = response.data.inputId;

          this.getAllItem(this.ID);

          this.number = response.data.outputDocumentNumber;
          this.numberinput = response.data.inputDocumentNumber;

          setTimeout(() => {
            this.wait(500);

            // poruka =
            //       "Uspešno je kreiran dokument broj " +
            //       response.data.outputDocumentNumber +
            //       ". Da li želite da izvršite " +
            //       pom_poruka +
            //       " vina iz magacina?";

            // if (this.warehouseType === "bottled_wine")
            //     poruka =
            //       "Uspešno su kreirani dokumenti međumagacinskog izlaza " +
            //       response.data.outputDocumentNumber +
            //       " i međumagacinskog prijema " +
            //       ". Da li želite da izvršite dokument dokument izlaza iz magacina?";
            //   else
            //     poruka =
            //       "Uspešno je kreiran dokument broj " +
            //       response.data.outputDocumentNumber +
            //       ". Da li želite da izvršite " +
            //       pom_poruka +
            //       " materijala iz magacina?";

            // poruka =
            //   "Uspešno su kreirani dokumenti međumagacinskog izlaza " +
            //   response.data.outputDocumentNumber +
            //   " i međumagacinskog prijema " +
            //   response.data.inputDocumentNumber +
            //   ". Da li želite da izvršite dokument izlaza iz magacina?";

            this.MMPLabel = response.data.inputDocumentNumber;
            this.MMILabel = response.data.outputDocumentNumber;

            this.MMPID = response.data.inputId;
            this.MMIID = response.data.outputId;

            // confirm(poruka) && this.prijemDokumenta(response.data.outputId);

            this.dialogSave = true;

            // this.clear();
          }, 10);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/change_warehouse/create",
                      complexInputMax,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;
                      // let pom_poruka;

                      // pom_poruka = "dokument izlaza iz magacina";

                      // let naslov = document.getElementById("naslov").innerText;
                      // document.getElementById("naslov").innerText =
                      //   naslov + " " + response.data.outputDocumentNumber;

                      let naslov = document.getElementById("naslov");
                      naslov.innerHTML =
                        "Međumagacinski izlaz " +
                        response.data.outputDocumentNumber +
                        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
                        response.data.inputDocumentNumber;

                      this.ID = response.data.outputId;
                      this.IDinput = response.data.inputId;

                      this.getAllItem(this.ID);

                      this.number = response.data.outputDocumentNumber;
                      this.numberinput = response.data.inputDocumentNumber;

                      setTimeout(() => {
                        this.wait(500);

                        // poruka =
                        //       "Uspešno je kreiran dokument broj " +
                        //       response.data.outputDocumentNumber +
                        //       ". Da li želite da izvršite " +
                        //       pom_poruka +
                        //       " vina iz magacina?";

                        // if (this.warehouseType === "bottled_wine")
                        //     poruka =
                        //       "Uspešno su kreirani dokumenti međumagacinskog izlaza " +
                        //       response.data.outputDocumentNumber +
                        //       " i međumagacinskog prijema " +
                        //       ". Da li želite da izvršite dokument dokument izlaza iz magacina?";
                        //   else
                        //     poruka =
                        //       "Uspešno je kreiran dokument broj " +
                        //       response.data.outputDocumentNumber +
                        //       ". Da li želite da izvršite " +
                        //       pom_poruka +
                        //       " materijala iz magacina?";

                        // poruka =
                        //   "Uspešno su kreirani dokumenti međumagacinskog izlaza " +
                        //   response.data.outputDocumentNumber +
                        //   " i međumagacinskog prijema " +
                        //   response.data.inputDocumentNumber +
                        //   ". Da li želite da izvršite dokument izlaza iz magacina?";

                        this.MMPLabel = response.data.inputDocumentNumber;
                        this.MMILabel = response.data.outputDocumentNumber;

                        this.MMPID = response.data.inputId;
                        this.MMIID = response.data.outputId;

                        // confirm(poruka) && this.prijemDokumenta(response.data.outputId);

                        this.dialogSave = true;

                        // this.clear();
                      }, 10);
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit_save() {
      if (this.valueMMP && !this.valueMMI)
        alert("Nije moguće iz međumagacinski prijem bez izlaza.");
      else if (this.valueMMP && this.valueMMI) {
        this.prijemObaDokumenta(this.MMPID, this.MMIID);
      } else if (this.valueMMI) {
        this.prijemDokumenta(this.MMIID);
      }
    },
    prijemDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokument je uspešno izvršen.");
          this.clear();

          if (this.executed_document) this.dialogSaveExecuted = false;
          else this.dialogSave = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokument je uspešno izvršen.");
                      this.clear();

                      if (this.executed_document)
                        this.dialogSaveExecuted = false;
                      else this.dialogSave = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);

                      //           if (this.executed_document) {
                      //   this.dialogSaveExecuted = false;
                      // } else this.dialogSave = false;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);

              //   if (this.executed_document) {
              //   this.dialogSaveExecuted = false;
              // } else this.dialogSave = false;
            }
          }
        });
    },
    prijemObaDokumenta(idMMP, idMMI) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            idMMI +
            "/" +
            idMMP,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokumenti su uspešno izvršeni.");
          this.clear();

          this.dialogSave = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        idMMI +
                        "/" +
                        idMMP,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokumenti su uspešno izvršeni.");
                      this.clear();

                      this.dialogSave = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);

                      //           if (this.executed_document) {
                      //   this.dialogSaveExecuted = false;
                      // } else this.dialogSave = false;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);

              //   if (this.executed_document) {
              //   this.dialogSaveExecuted = false;
              // } else this.dialogSave = false;
            }
          }
        });
    },
    getFieldTextWine(item) {
      return `${item.label} ${item.year}`;
    },
    changeWine(a) {
      this.load = this.load + 1;

      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);

            this.getAllWareHouseState(a);

            // if (this.load > 1) this.aditiv_select = undefined;
          }
        } else {
          this.getAllWareHouseState(a.id);

          // if (this.load > 1) this.aditiv_select = undefined;
        }
      }
    },
    changeSifarnik() {
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var pom_receive_to_select;

      if (
        typeof this.receive_to_select !== "undefined" &&
        this.receive_to_select !== ""
      ) {
        if (typeof this.receive_to_select.id === "undefined")
          pom_receive_to_select = this.receive_to_select;
        else pom_receive_to_select = this.receive_to_select.id;
      }

      var url;

      if (!this.executed_document)
        url = "/warehouse_input_output/change_warehouse/update";
      else url = "/warehouse_input_output/change_warehouse/update_executed";

      var complexInput;

      if (this.executed_document)
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "CHANGE_WAREHOUSE_OUTPUT",
          give: {
            id: pom_give_to_select,
          },
          receive: {
            id: pom_receive_to_select,
          },
          description: this.opis,
          warehouseInputOutputItems: [],
          changeWarehouseRelatedId: this.IDinput,
          output: true,
        };
      else
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: "CHANGE_WAREHOUSE_OUTPUT",
          give: {
            id: pom_give_to_select,
          },
          receive: {
            id: pom_receive_to_select,
          },
          description: this.opis,
          warehouseInputOutputItems: this.items_modal,
          output: true,
        };
      var pom_warehouses_select;

      if (
        typeof this.warehouses_select !== "undefined" &&
        this.warehouses_select !== ""
      ) {
        if (typeof this.warehouses_select.id === "undefined")
          pom_warehouses_select = this.warehouses_select;
        else pom_warehouses_select = this.warehouses_select.id;
      }

      var complexObjectWareHouseOutput = {
        id: pom_warehouses_select,
      };

      var pom_give_to_select_output = 0;

      if (
        typeof this.give_to_select_output !== "undefined" &&
        this.give_to_select_output !== "" &&
        this.give_to_select_output !== null
      ) {
        if (typeof this.give_to_select_output.id === "undefined")
          pom_give_to_select_output = this.give_to_select_output;
        else pom_give_to_select_output = this.give_to_select_output.id;
      }

      var pom_receive_to_select_output = 0;

      if (
        typeof this.receive_to_select_output !== "undefined" &&
        this.receive_to_select_output !== "" &&
        this.receive_to_select_output !== null
      ) {
        if (typeof this.receive_to_select_output.id === "undefined")
          pom_receive_to_select_output = this.receive_to_select_output;
        else pom_receive_to_select_output = this.receive_to_select_output.id;
      }

      var complexOutput;

      if (pom_give_to_select_output !== 0 && pom_receive_to_select_output !== 0)
        if (this.executed_document)
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            give: {
              id: pom_give_to_select_output,
            },
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            give: {
              id: pom_give_to_select_output,
            },
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            input: true,
          };
      else if (
        pom_give_to_select_output === 0 &&
        pom_receive_to_select_output === 0
      )
        if (this.executed_document)
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            description: this.opis_novi,
            input: true,
          };
      else if (pom_give_to_select_output === 0)
        if (this.executed_document)
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            changeWarehouseRelatedId: this.ID,
            input: true,
          };
        else
          complexOutput = {
            id: this.IDinput,
            number: this.numberinput,
            warehouse: complexObjectWareHouseOutput,
            date: this.date2 + "T" + this.time2,
            type: "CHANGE_WAREHOUSE_INPUT",
            receive: {
              id: pom_receive_to_select_output,
            },
            description: this.opis_novi,
            input: true,
          };
      else if (this.executed_document)
        complexOutput = {
          id: this.IDinput,
          number: this.numberinput,
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          give: {
            id: pom_give_to_select_output,
          },
          description: this.opis_novi,
          changeWarehouseRelatedId: this.ID,
          input: true,
        };
      else
        complexOutput = {
          id: this.IDinput,
          number: this.numberinput,
          warehouse: complexObjectWareHouseOutput,
          date: this.date2 + "T" + this.time2,
          type: "CHANGE_WAREHOUSE_INPUT",
          give: {
            id: pom_give_to_select_output,
          },
          description: this.opis_novi,
          input: true,
        };

      console.log(complexInput);

      var complexInputMax;
      complexInputMax = {
        warehouseOutput: complexInput,
        warehouseInput: complexOutput,
      };

      console.log(complexInput);

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + url,
          complexInputMax,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
          let poruka;

          // poruka =
          //   "Uspešno su izmenjeni dokumenti međumagacinskog izlaza " +
          //   this.number +
          //   " i međumagacinskog prijema " +
          //   this.numberinput +
          //   ". Da li želite da izvršite dokument izlaza iz magacina?";

          // confirm(poruka) && this.prijemDokumenta(this.ID);

          // this.clear();

          setTimeout(() => {
            this.wait(500);

            this.MMPLabel = this.numberinput;
            this.MMILabel = this.number;

            this.MMPID = this.IDinput;
            this.MMIID = this.ID;

            if (this.executed_document) {
              this.valueMMP = true;
              this.dialogSaveExecuted = true;
            } else this.dialogSave = true;
          }, 10);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + url,
                      complexInputMax,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;
                      let poruka;

                      // poruka =
                      //   "Uspešno su izmenjeni dokumenti međumagacinskog izlaza " +
                      //   this.number +
                      //   " i međumagacinskog prijema " +
                      //   this.numberinput +
                      //   ". Da li želite da izvršite dokument izlaza iz magacina?";

                      // confirm(poruka) && this.prijemDokumenta(this.ID);

                      // this.clear();

                      setTimeout(() => {
                        this.wait(500);

                        this.MMPLabel = this.numberinput;
                        this.MMILabel = this.number;

                        this.MMPID = this.IDinput;
                        this.MMIID = this.ID;

                        if (this.executed_document) {
                          this.valueMMP = true;
                          this.dialogSaveExecuted = true;
                        } else this.dialogSave = true;
                      }, 10);
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnikUlaza() {
      let complexPouringAdditiv;

      let noviNiz = [];

      this.items_modal.forEach(function (element) {
        complexPouringAdditiv = {
          id: element.id,

          quantity: Number(element.quantity),
        };

        noviNiz.push(complexPouringAdditiv);
      });

      var complexInput;

      var pom_give_to_select_output = 0;

      if (
        typeof this.give_to_select_output !== "undefined" &&
        this.give_to_select_output !== "" &&
        this.give_to_select_output !== null
      ) {
        if (typeof this.give_to_select_output.id === "undefined")
          pom_give_to_select_output = this.give_to_select_output;
        else pom_give_to_select_output = this.give_to_select_output.id;
      }

      var pom_receive_to_select_output = 0;

      if (
        typeof this.receive_to_select_output !== "undefined" &&
        this.receive_to_select_output !== "" &&
        this.receive_to_select_output !== null
      ) {
        if (typeof this.receive_to_select_output.id === "undefined")
          pom_receive_to_select_output = this.receive_to_select_output;
        else pom_receive_to_select_output = this.receive_to_select_output.id;
      }

      if (pom_give_to_select_output !== 0 && pom_receive_to_select_output !== 0)
        complexInput = {
          id: this.IDinput,
          date: this.date2 + "T" + this.time2,
          give: {
            id: pom_give_to_select_output,
          },
          receive: {
            id: pom_receive_to_select_output,
          },
          description: this.opis_novi,
          warehouseInputOutputItems: noviNiz,
        };
      else if (
        pom_give_to_select_output === 0 &&
        pom_receive_to_select_output === 0
      )
        complexInput = {
          id: this.IDinput,
          date: this.date2 + "T" + this.time2,
          description: this.opis_novi,
          warehouseInputOutputItems: noviNiz,
        };
      else if (pom_give_to_select_output === 0)
        complexInput = {
          id: this.IDinput,
          date: this.date2 + "T" + this.time2,
          receive: {
            id: pom_receive_to_select_output,
          },
          description: this.opis_novi,
          warehouseInputOutputItems: noviNiz,
        };
      else
        complexInput = {
          id: this.IDinput,
          date: this.date2 + "T" + this.time2,
          give: {
            id: pom_give_to_select_output,
          },
          description: this.opis_novi,
          warehouseInputOutputItems: noviNiz,
        };

      console.log(complexInput);

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/change_warehouse/update/input",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          // poruka =
          //   "Uspešno je izmenjen dokument međumagacinskog ulaza " +
          //   this.numberinput +
          //   ". Da li želite da izvršite dokument ulaza u magacin?";

          poruka = "Da li želite da izvršite dokument ulaza u magacin?";

          if (this.tip_dokumenta === "MMI")
            confirm(poruka) && this.prijemDokumenta(this.ID);
          else confirm(poruka) && this.prijemDokumenta(this.IDinput);

          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/change_warehouse/update/input",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      // poruka =
                      //   "Uspešno je izmenjen dokument međumagacinskog ulaza " +
                      //   this.numberinput +
                      //   ". Da li želite da izvršite dokument ulaza u magacin?";

                      poruka = "Da li želite da izvršite dokument ulaza u magacin?";

                      if (this.tip_dokumenta === "MMI")
                        confirm(poruka) && this.prijemDokumenta(this.ID);
                      else
                        confirm(poruka) && this.prijemDokumenta(this.IDinput);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    editItemModal(item) {
      this.load = 0;

      this.index_izmene = this.items_modal_pom.indexOf(item);

      this.dialogNote = true;

      let pronadjiObjNovi;

      if (typeof item.wine !== "undefined")
        pronadjiObjNovi = this.wine_to_items.find(
          (item1) => item1.id === item.wine.id
        );
      else
        pronadjiObjNovi = this.wine_to_items.find(
          (item1) => item1.id === item.warehouseState
        );

      if (pronadjiObjNovi !== undefined) {
        this.wine_to_select = pronadjiObjNovi;
        this.wine_to_select_disable = false;

        this.modal_lot = item.bottling.lot;

        if (this.promeni_lot) {
          this.promeni_lot = false;
          this.getAllWareHouseState(pronadjiObjNovi.id);
        }
      } else {
        this.wine_to_items.push(item.wine);
        this.wine_to_select = item.wine;

        this.promeni_lot = true;

        this.pomocni_text_pom = item.wine.label + " " + item.wine.year;
        this.wine_to_select_disable = true;
      }

      this.pomocni_text = item.bottling.lot;

      // if(this.tip_dokumenta === "MMI")
      this.globBottlingID = item.bottling.stateId;

      this.quantity = item.quantity;

      this.modal_zapremina = item.bottling.bottleVolumeInLitres;

      if (!this.edit_form) this.pomocni_text = item.bottling.lot;
    },
    submit() {
      if (this.items_modal.length < 1)
        alert("Niste izabrali ni jednu stavku dokumenta.");
      else if (this.$refs.form.validate() && this.$refs.form1.validate()) {
        // if (this.tip_dokumenta === "MMP") this.changeSifarnikUlaza();
        // else if (this.ID != "" && this.ID != "0") this.changeSifarnik();
        // else this.newSifarnik();
        if (this.tip_dokumenta === "MMP") {
          this.isLoading = true;

          setTimeout(() => {
            this.changeSifarnikUlaza();
          }, 1000);
        } else {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") this.changeSifarnik();
            else this.newSifarnik();
          }, 1000);
        }
      }
    },
    getAllItem(id) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/change_warehouse/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let pom_items;
          let pom_items1;

          // let pomBool;

          this.print_item = response.data[0];
            this.print_item_out = response.data[1];

          if (response.data[0].number.substring(0, 3) === "MMI") {
            pom_items = response.data[0];
            pom_items1 = response.data[1];
          } else {
            pom_items = response.data[1];
            pom_items1 = response.data[0];

            //this.number = item.number;

            // pomBool = false;
          }

          this.numberinput = pom_items1.number;
          this.IDinput = pom_items1.id;
          this.give_to_select_output = pom_items1.give;
          this.receive_to_select_output = pom_items1.receive;
          this.opis_novi = pom_items1.description;
          this.date2 = pom_items1.date.split("T")[0];
          this.time2 = this.formatTime(pom_items1.date.split("T")[1]);

          this.number = pom_items.number;
          this.ID = pom_items.id;
          this.warehouses_select = pom_items1.warehouse;

          if (this.tip_dokumenta !== "MMI")
            this.magacin_prijema = pom_items.warehouse.name;
          else this.magacin_prijema = pom_items1.warehouse.name;

          this.opis = pom_items.description;
          this.date = pom_items.date.split("T")[0];
          this.time = this.formatTime(pom_items.date.split("T")[1]);

          this.give_to_select = pom_items.give;
          this.receive_to_select = pom_items.receive;

          this.items_modal = [];
          this.items_modal_pom = [];

          let complexPouringAdditiv;
          let complexPouringAdditivPom;

          let naslov = document.getElementById("naslov");
          // naslov.innerHTML =
          //   "Međumagacinski izlaz " +
          //   this.number +
          //   "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
          //   this.numberinput;

          if (pom_items.executed && pom_items1.executed)
            naslov.innerHTML =
              "Međumagacinski izlaz " +
              this.number +
              '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
              pom_items.executed +
              '">' +
              "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
              this.numberinput +
              '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
              pom_items1.executed +
              '">';
          else if (pom_items.executed)
            naslov.innerHTML =
              "Međumagacinski izlaz " +
              this.number +
              '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
              pom_items.executed +
              '">' +
              "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
              this.numberinput;
          else
            naslov.innerHTML =
              "Međumagacinski izlaz " +
              this.number +
              "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
              this.numberinput;

          let _this = this;

          if (this.tip_dokumenta === "MMI")
            pom_items.warehouseInputOutputItems.forEach(function (element) {
              complexPouringAdditiv = {
                id: element.id,
                warehouseState: {
                  id: element.warehouseState.id,
                },
                quantity: Number(element.quantity),
              };

              complexPouringAdditivPom = {
                id: element.id,
                wine: {
                  id: element.articleId,
                  label: element.wineName,
                  year: element.wineYear,
                },
                bottling: {
                  stateId: element.warehouseState.id,
                  bottleVolumeInLitres: element.bottleVolumeInLitres,
                  bottledNumber: 10,
                  bottlesUnreceived: 0,
                  dateOfProduction: element.bottlingOrProductionDate,
                  lot: element.lot,
                  tank: element.tank,
                  tankPhaseWineId: element.tankPhaseWineId,
                },
                quantity: Number(element.quantity),
              };

              _this.items_modal.push(complexPouringAdditiv);
              _this.items_modal_pom.push(complexPouringAdditivPom);
            });
          else
            pom_items1.warehouseInputOutputItems.forEach(function (element) {
              complexPouringAdditiv = {
                id: element.id,
                quantity: Number(element.quantity),
              };

              complexPouringAdditivPom = {
                id: element.id,
                wine: {
                  id: element.articleId,
                  label: element.wineName,
                  year: element.wineYear,
                },
                bottling: {
                  stateId: 0,
                  bottleVolumeInLitres: element.bottleVolumeInLitres,
                  bottledNumber: 10,
                  bottlesUnreceived: 0,
                  dateOfProduction: element.bottlingOrProductionDate,
                  lot: element.lot,
                  tank: element.tank,
                  tankPhaseWineId: element.tankPhaseWineId,
                },
                quantity: Number(element.quantity),
              };

              _this.items_modal.push(complexPouringAdditiv);
              _this.items_modal_pom.push(complexPouringAdditivPom);
            });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/change_warehouse/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let pom_items;
                      let pom_items1;

                      // let pomBool;

                      if (response.data[0].number.substring(0, 3) === "MMI") {
                        pom_items = response.data[0];
                        pom_items1 = response.data[1];

                        // pomBool = true;
                      } else {
                        pom_items = response.data[1];
                        pom_items1 = response.data[0];

                        //this.number = item.number;

                        // pomBool = false;
                      }

                      this.numberinput = pom_items1.number;
                      this.IDinput = pom_items1.id;
                      this.give_to_select_output = pom_items1.give;
                      this.receive_to_select_output = pom_items1.receive;
                      this.opis_novi = pom_items1.description;
                      this.date2 = pom_items1.date.split("T")[0];
                      this.time2 = this.formatTime(
                        pom_items1.date.split("T")[1]
                      );

                      this.number = pom_items.number;
                      this.ID = pom_items.id;
                      this.warehouses_select = pom_items1.warehouse;

                      if (this.tip_dokumenta !== "MMI")
                        this.magacin_prijema = pom_items.warehouse.name;
                      else this.magacin_prijema = pom_items1.warehouse.name;

                      this.opis = pom_items.description;
                      this.date = pom_items.date.split("T")[0];
                      this.time = this.formatTime(pom_items.date.split("T")[1]);

                      this.give_to_select = pom_items.give;
                      this.receive_to_select = pom_items.receive;

                      this.items_modal = [];
                      this.items_modal_pom = [];

                      let complexPouringAdditiv;
                      let complexPouringAdditivPom;

                      let naslov = document.getElementById("naslov");
                      // naslov.innerHTML =
                      //   "Međumagacinski izlaz " +
                      //   this.number +
                      //   "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
                      //   this.numberinput;

                      if (pom_items.executed && pom_items1.executed)
                        naslov.innerHTML =
                          "Međumagacinski izlaz " +
                          this.number +
                          '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
                          pom_items.executed +
                          '">' +
                          "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
                          this.numberinput +
                          '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
                          pom_items1.executed +
                          '">';
                      else if (pom_items.executed)
                        naslov.innerHTML =
                          "Međumagacinski izlaz " +
                          this.number +
                          '&nbsp;<img src="./../assets/menuIcons/check-circle.svg" style="vertical-align:sub;" title="Dokument je izvršen." width="24" height="24" v-if="' +
                          pom_items.executed +
                          '">' +
                          "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
                          this.numberinput;
                      else
                        naslov.innerHTML =
                          "Međumagacinski izlaz " +
                          this.number +
                          "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Međumagacinski prijem " +
                          this.numberinput;

                      // this.magacin_prijema = this.warehouses_select.name;

                      let _this = this;

                      if (this.tip_dokumenta === "MMI")
                        pom_items.warehouseInputOutputItems.forEach(function (
                          element
                        ) {
                          complexPouringAdditiv = {
                            id: element.id,
                            warehouseState: {
                              id: element.warehouseState.id,
                            },
                            quantity: Number(element.quantity),
                          };

                          complexPouringAdditivPom = {
                            id: element.id,
                            wine: {
                              id: element.articleId,
                              label: element.wineName,
                              year: element.wineYear,
                            },
                            bottling: {
                              stateId: element.warehouseState.id,
                              bottleVolumeInLitres:
                                element.bottleVolumeInLitres,
                              bottledNumber: 10,
                              bottlesUnreceived: 0,
                              dateOfProduction:
                                element.bottlingOrProductionDate,
                              lot: element.lot,
                              tank: element.tank,
                              tankPhaseWineId: element.tankPhaseWineId,
                            },
                            quantity: Number(element.quantity),
                          };

                          _this.items_modal.push(complexPouringAdditiv);
                          _this.items_modal_pom.push(complexPouringAdditivPom);
                        });
                      else
                        pom_items1.warehouseInputOutputItems.forEach(function (
                          element
                        ) {
                          complexPouringAdditiv = {
                            id: element.id,
                            quantity: Number(element.quantity),
                          };

                          complexPouringAdditivPom = {
                            id: element.id,
                            wine: {
                              id: element.articleId,
                              label: element.wineName,
                              year: element.wineYear,
                            },
                            bottling: {
                              stateId: 0,
                              bottleVolumeInLitres:
                                element.bottleVolumeInLitres,
                              bottledNumber: 10,
                              bottlesUnreceived: 0,
                              dateOfProduction:
                                element.bottlingOrProductionDate,
                              lot: element.lot,
                              tank: element.tank,
                              tankPhaseWineId: element.tankPhaseWineId,
                            },
                            quantity: Number(element.quantity),
                          };

                          _this.items_modal.push(complexPouringAdditiv);
                          _this.items_modal_pom.push(complexPouringAdditivPom);
                        });
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  beforeMount() {
    serverBus.$on("wh_change", (id, tip_magacina, it_tip_magacina, item) => {
      // console.log(item);

      this.warehouseID = id;
      this.warehouseType = tip_magacina;
      this.warehouseTypeId = it_tip_magacina;

      if (item !== null && typeof item !== "undefined") {
        // this.getAllArticles();
        // this.getAllJediniceMere();
        this.getAllWine();

        this.edit_form = item.edit;
        this.executed_document = item.executed;
        this.date_document = item.date;

        if (item.documentNumber !== undefined) {
          this.number = item.documentNumber;
          this.tip_dokumenta = item.documentNumber.substring(0, 3);
        } else {
          this.number = item.number;
          this.tip_dokumenta = item.number.substring(0, 3);
        }

        this.getAllItem(item.id);
      }
    });
  },
  mounted() {
    this.clearInit();
    this.getAllEmployees();
    this.getAllWareHouses();
    // this.setTime();
    // this.setDate();
  },

  destroyed() {
    serverBus.$off("wh_change");
  },
};
</script>

<style lang="scss" scoped>
@import "./parts/../../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}
#Odustani_dugme {
  text-align: right !important;
}
</style>
